import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
// import "../../mixins.scss";
import './menu.scss';

function Menu(props) {
  const { components, page, menuActive, setCurrentDate, setMenuActive } = props;

  const setData = (e) => {
    setCurrentDate(e);
    setMenuActive(false);
  };

  return (
    <>
      <div className={cn('nav', menuActive && '_open-navbar')}>
        <div className="nav__wrap">
          <div className="nav__header">
            <div className="nav__logo">
              <a href="/">
                <img src="img/logo-white.svg" alt="logo" />
              </a>
			  <button className="nav__close" onClick={() => setMenuActive(false)}>
			  	Закрыть
			  </button>
            </div>
          </div>
          <div className="nav__menu">
            <ul>
              <li>
                <div className="nav__menu-title" onClick={() => setData({ years: 1, month: 0 })}>Начало истории</div>
                <ul>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="1"
                      onClick={() => setData({ years: 2007, month: 0 })}>
                      2007
                    </a>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="2"
                      onClick={() => setData({ years: 2008, month: 0 })}>
                      2008
                    </a>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="3"
                      onClick={() => setData({ years: 2009, month: 0 })}>
                      2009
                    </a>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="4"
                      onClick={() => setData({ years: 2010, month: 0 })}>
                      2010
                    </a>
                    <div className="nav__menu-months nav__menu-months--2010">
                      <a href="#" data-section-index="4" className="nav__menu-month">
                        [апр]
                      </a>
                      <a href="#" data-section-index="5" className="nav__menu-month">
                        [сен]
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="6"
                      onClick={() => setData({ years: 2011, month: 0 })}>
                      2011
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <div className="nav__menu-title" onClick={() => setData({ years: 2012, month: 0, start: true })}>Большой прорыв</div>
                <ul>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="1"
                      onClick={() => setData({ years: 2012, month: 0 })}>
                      2012
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="1">
                        [янв]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="2">
                        [дек]
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="3"
                      onClick={() => setData({ years: 2013, month: 0 })}>
                      2013
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="3">
                        [мар]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="4">
                        [сен]
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="5"
                      onClick={() => setData({ years: 2014, month: 0 })}>
                      2014
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="5">
                        [фев]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="6">
                        [мар]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="7">
                        [сен]
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="8"
                      onClick={() => setData({ years: 2015, month: 0 })}>
                      2015
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="8">
                        [окт]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="9">
                        [дек]
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="10"
                      onClick={() => setData({ years: 2016, month: 0 })}>
                      2016
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="10">
                        [мар]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="11">
                        [июн]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="12">
                        [дек]
                      </a>
                    </div>
                  </li>
                </ul>
              </li>
              <li>
                <div className="nav__menu-title"  onClick={() => setData({ years: 2017, month: 0 })}>Авито сегодня</div>
                <ul>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="1"
                      onClick={() => setData({ years: 2017, month: 0 })}>
                      2017
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="1">
                        [янв]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="2">
                        [мар]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="3">
                        [дек]
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="4"
                      onClick={() => setData({ years: 2018, month: 0 })}>
                      2018
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="4">
                        [мар]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="5">
                        [июн]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="6">
                        [окт]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="7">
                        [ноя]
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="9"
                      onClick={() => setData({ years: 2019, month: 0 })}>
                      2019
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="9">
                        [янв]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="10">
                        [май]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="11">
                        [июн]
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="12"
                      onClick={() => setData({ years: 2020, month: 0 })}>
                      2020
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="12">
                        [янв]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="13">
                        [мар]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="14">
                        [июн]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="15">
                        [дек]
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="16"
                      onClick={() => setData({ years: 2021, month: 0 })}>
                      2021
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="16">
                        [янв]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="17">
                        [фев]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="18">
                        [май]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="19">
                        [сен]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="20">
                        [дек]
                      </a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav__menu-year"
                      href="#"
                      data-section-index="20"
                      onClick={() => setData({ years: 2022, month: 0 })}>
                      2022
                    </a>
                    <div className="nav__menu-months">
                      <a href="#" className="nav__menu-month" data-section-index="21">
                        [мар]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="22">
                        [окт]
                      </a>
                      <a href="#" className="nav__menu-month" data-section-index="23">
                        [ноя]
                      </a>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="nav__submenu">
            <ul className="nav__links">
              {/* <li>
                <a href="#">Награды</a>
              </li>
              <li>
                <a href="#">Сотрудники</a>
              </li>
              <li>
                <a href="#">Сеть доставок</a>
              </li> */}
            </ul>
			<ul className="nav__socials">
				{/* <li><a href="#">Facebook</a></li>
				<li><a href="#">Instagram</a></li>
				<li><a href="#">Twitter</a></li>
				<li><a href="#">Linkedin</a></li> */}
			</ul>
          </div>
          <div className="nav__footer">
            {/* <div className="nav__social">
              <a href="#">
                <img src="../img/nav-icon_fb.svg" alt="" />
              </a>
              <a href="#">
                <img src="../img/nav-icon_tw.svg" alt="" />
              </a>
              <a href="#">
                <img src="../img/nav-icon_inst.svg" alt="" />
              </a>
              <a href="#">
                <img src="../img/nav-icon_in.svg" alt="" />
              </a>
            </div> */}
            {/* <div className="nav__share">
              <a href="#">
                Поделится
                <img src="/img/icons/nav-icon-white-share.svg" alt="" />
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default Menu;
